import styled from 'styled-components';
import StyledSnapper from './StyledSnapper';

const StyledSnapLayout = styled.div`
display: grid;
grid-column-gap: 3px;
grid-row-gap: 3px;

&:nth-child(1) {
  grid-template-columns: auto auto;
}

&:nth-child(2) {
  grid-template-columns: auto auto auto;

  .snapper:first-child {
    grid-column-end: span 2;
  }
}

&:nth-child(3) {
  grid-template-columns: auto auto auto;
}

&:nth-child(4) {
  grid-template-columns: auto auto;
  grid-template-rows: auto auto;

  ${StyledSnapper}:first-child {
    grid-row: 1 / span 2;
  }
}

&:nth-child(5) {
  grid-template-columns: auto auto;
  grid-template-rows: auto auto;
  grid-column-gap: 4px;
}

&:nth-child(6) {
  grid-template-columns: auto auto auto auto auto auto auto;

  ${StyledSnapper} {
    grid-column-end: span 2;
  }

  ${StyledSnapper}:nth-child(2) {
    grid-column: 3 / span 3;
  }
}
}
`;

export default StyledSnapLayout;